import React, { useState, useEffect } from 'react';
import GraficaMeteoHumedad from "./GraficaMeteoHumedad";
import GraficaMeteoIntensidadLluvia from "./GraficaMeteoIntensidadLluvia";
import GraficaMeteoLluviaDiaria from "./GraficaMeteoLluviaDiaria";
import GraficaMeteoLluviaUltimasHoras from "./GraficaMeteoLluviaUltimasHoras";
import GraficaMeteoTemperatura from "./GraficaMeteoTemperatura";
import GraficaMeteoVelocidadViento from "./GraficaMeteoVelocidadViento";
import GraficaMeteoDireccionViento from "./GraficaMeteoDireccionViento";
import useMeteoStations from '../../hooks/useGetMeteoStations';
import { getMeteoData, getMeteoDailyRain } from '../../api/meteo';
import './MeteoDashboard.css';
import AvametLinks from './AvametLinks';

const MeteoDashboard = ({ meteoId: initialMeteoId, can }) => {
  const { stations, loading, error } = useMeteoStations();
  const [selectedStation, setSelectedStation] = useState(initialMeteoId || '');
  const defaultStart = new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString();
  const defaultEnd = new Date().toISOString();
  const [start, setStart] = useState(defaultStart);
  const [end, setEnd] = useState(defaultEnd);

  const MAX_RANGE_MS = 45 * 24 * 60 * 60 * 1000; // 45 días

  const validateRange = (newStart, newEnd) => {
    const startDate = new Date(newStart);
    const endDate = new Date(newEnd);

    // Si el inicio es después del final → corregimos
    if (startDate > endDate) return false;

    // Si supera 30 días → no permitimos
    if (endDate - startDate > MAX_RANGE_MS) return false;

    return true;
  };

  const handleStartChange = (value) => {
    const iso = new Date(value).toISOString();

    if (validateRange(iso, end)) {
      setStart(iso);
    } else {
      alert("El intervalo máximo permitido es de 30 días");
    }
  };

  const handleEndChange = (value) => {
    const iso = new Date(value).toISOString();

    if (validateRange(start, iso)) {
      setEnd(iso);
    } else {
      alert("El intervalo máximo permitido es de 30 días");
    }
  };

  const handleDownload = async () => {
    try {
      const blob = await getMeteoData({
        meteoId: selectedStation,
        start,
        end,
        parameter: "all",
        format: "csv"
      });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `meteo_${selectedStation}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error(err);
      alert("Error descargando datos");
    }
  };

  const handleDownloadDailyRain = async () => {
    try {
      const blob = await getMeteoDailyRain({ meteoId: selectedStation, start, end });

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = url;
      link.download = `lluvia_diaria_${selectedStation}.csv`;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error(err);
      alert("Error descargando la lluvia diaria");
    }
  };





  useEffect(() => {
    if (stations.length && !selectedStation) {
      setSelectedStation(stations[0].id);
    }
  }, [stations, selectedStation]);


  if (loading) return <p>Cargando estaciones meteorológicas...</p>;
  if (error) return <p>Error: {error}</p>;
  if (!selectedStation) return <p>Selecciona una estación para continuar</p>;

  

  return (
    <div className="meteo-dashboard">
      <AvametLinks />
    <div className="dashboard-header">
      
      <h2>
        <span style={{fontSize: "28px"}}>{stations.find(s => s.id === selectedStation)?.name || selectedStation}</span>
      </h2>


      <select
        value={selectedStation}
        onChange={(e) => setSelectedStation(e.target.value)}
        className="station-selector"
      >
        {stations.map((station) => (
          <option key={station.id} value={station.id}>
            {station.name}
          </option>
        ))}
      </select>

       <div className="time-range-selector">
      


        <label>
          Inicio:
          <input
            type="datetime-local"
            value={start.slice(0, 16)}
            onChange={(e) => handleStartChange(e.target.value)}
          />
        </label>

        <label>
          Fin:
          <input
            type="datetime-local"
            value={end.slice(0, 16)}
            onChange={(e) => handleEndChange(e.target.value)}
          />
        </label>

      </div>

      <button
        className="download-button"
        onClick={handleDownload}
      >
        Descargar datos
      </button>

      {can?.(['admin']) && (
        <button
          className="download-button"
          onClick={handleDownloadDailyRain}
        >
          Descargar lluvia diaria
        </button>
      )}

    </div>

    <div className="dashboard-grid">
      <GraficaMeteoTemperatura meteoId={selectedStation} start={start} end={end} />
      <GraficaMeteoHumedad meteoId={selectedStation} start={start} end={end} />
      <GraficaMeteoLluviaUltimasHoras meteoId={selectedStation} start={start} end={end} />
      <GraficaMeteoIntensidadLluvia meteoId={selectedStation} start={start} end={end} />
      <GraficaMeteoLluviaDiaria meteoId={selectedStation} start={start} end={end} />
      <GraficaMeteoVelocidadViento meteoId={selectedStation} start={start} end={end} />
      <GraficaMeteoDireccionViento meteoId={selectedStation} start={start} end={end} />
    </div>
  </div>

  );
};

export default MeteoDashboard;
